import React, { FC, useMemo } from 'react';
import { useIspmContext } from '../../IspmContext';
import { DonutChart, LayoutCarousel } from '@silverfort/sf-components';
import { DonutChartData } from '@silverfort/sf-components/dist/Charts/DonutChart/types';

type IspmPieWidgetProps = {
    data: Array<DonutChartData>;
    title: string;
    selectedItems?: (string | number)[];
};

const IspmPieWidget: FC<IspmPieWidgetProps> = ({ data, title, selectedItems = [] }) => {
    const { isLoadingPageData } = useIspmContext();

    const total = useMemo(() => data.reduce((total, item) => total + item.value, 0), [data]);

    return (
        <LayoutCarousel
            pages={
                <DonutChart
                    chartSize={120}
                    data={data}
                    innerRadius={50}
                    isLoading={isLoadingPageData}
                    isMappingVisible
                    outerRadius={60}
                    totalText={total}
                    selectedItems={selectedItems}
                />
            }
            title={title}
        />
    );
};

export default IspmPieWidget;
